export const SUBSCRIPTION_EXPIRED_MESSAGE = 'Your subscription has expired. Upgrade to continue using Tailly.'
